
// need to be put on each page even thoug it's global otherwise card-profile doesnt work anymore
export { default as Modal } from '../modal';
export { default as ModalControl } from '../modalControl';
export { default as Form } from '../form';
export { default as FormQualification } from '../formQualification';
export { default as FormValidation } from '../formValidation';

export { default as CustomSelect } from '../customSelect';
export { default as CardProfile } from '../cardProfile';
export { default as VideoModalManager } from '../videoModalManager';
export { default as VideoPlayer } from '../videoPlayer';
export { default as ImplantationsMap } from '../implantationsMap';
export { default as SickyButton } from '../stickyButton';
